import PropTypes from 'prop-types';
import { Col, Row } from "reactstrap";
import InputController from "../../../../../core/ui/components/InputController";
import SelectController from "../../../../../core/ui/components/SelectController";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const AreasTab = ({ errors, control, selects }) => {
    return (
        <Row>
            <Col sm={6}>
                <SelectController
                    label="Cargo"
                    errors={errors}
                    control={control}
                    name="cargo_id"
                    rules={REQUIRED_RULE}
                    placeholder="Cargo"
                    options={selects.positions}
                />
            </Col>
            <Col sm={6}>
                <SelectController
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    name="parametro_riesgo_ocupacional_id"
                    label="Riesgo ocupacional"
                    options={selects.occupationalRisks}
                />
            </Col>
            <Col sm={12}>
                <InputController
                    type="textarea"
                    label="Observaciones"
                    errors={errors}
                    control={control}
                    name="observacion"
                    placeholder="Observaciones"
                />
            </Col>
        </Row>
    );
};

AreasTab.propTypes = {
    errors: PropTypes.object,
    control: PropTypes.object,
    selects: PropTypes.object,
};

export default AreasTab;

